import { isAfter, isBefore } from 'date-fns';
import { useState, useCallback } from 'react';
import { MIN_DATE, MAX_DATE } from './constants.esm.js';

function clampDate(provisional, min, max) {
    if (isAfter(provisional, max)) {
        return max;
    }
    else if (isBefore(provisional, min)) {
        return min;
    }
    return provisional;
}
function useActiveDate(_a) {
    var initialActiveDate = _a.initialActiveDate, _b = _a.min, min = _b === void 0 ? MIN_DATE : _b, _c = _a.max, max = _c === void 0 ? MAX_DATE : _c;
    var _d = useState(initialActiveDate), activeDate = _d[0], setActiveDateInner = _d[1];
    var setActiveDate = useCallback(function (inner) {
        if (typeof inner === "function") {
            setActiveDateInner(function (prevActiveDate) {
                var provisionalNextDate = inner(prevActiveDate);
                return clampDate(provisionalNextDate, min, max);
            });
        }
        else {
            setActiveDateInner(clampDate(inner, min, max));
        }
    }, [min, max]);
    return [activeDate, setActiveDate];
}

export { useActiveDate };
//# sourceMappingURL=useActiveDate.esm.js.map
